// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"825":"tws-breadcrumb-container","903":"tws-pebble-background-container"}[chunkId] + "." + {"825":"679cbafd0ee000e3","903":"2e0b971d74d77a3f"}[chunkId] + ".js";
};